/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Account_Audit_Active_SessionsInputs */

const fr_account_audit_active_sessions = /** @type {(inputs: Account_Audit_Active_SessionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sessions ouvertes : ${i?.count}`)
};

/**

* @param {Account_Audit_Active_SessionsInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const account_audit_active_sessions = /** @type {((inputs: Account_Audit_Active_SessionsInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Audit_Active_SessionsInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_account_audit_active_sessions(inputs)
});